/**
 * @see https://kakaoad.github.io/kakao-pixel/
 */

export type KakaoPixel = (trackId: string) => {
  pageView: () => void;
  completeRegistration: () => void;
  purchase: (payload: KakaoPixelPurchasePayload) => void;
};

export const KakaoPixelEvent = {
  SIGN_UP: 'SIGN_UP',
} as const;

export type KakaoPixelEventType = keyof typeof KakaoPixelEvent;

export type KakaoPixelPurchasePayload = {
  total_quantity: string;
  total_price: string;
  currency: 'KRW';
  products: Array<{
    id: string;
    name: string;
    quantity: string;
    price: string;
  }>;
};
